import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * Kept for links made before spec 224 grouped this page under another entry:
 * Triggers is a tab of Integrations now. The search carries over, so a link that opened a form or a period still
 * does.
 */
export const Route = createFileRoute('/workspaces/$workspaceId/triggers')({
  validateSearch: z.object({ create: z.boolean().optional().catch(undefined) }),
  beforeLoad: ({ params, search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/workspaces/$workspaceId/integrations/triggers',
      params: { workspaceId: params.workspaceId },
      search: search,
      replace: true,
    });
  },
});
